module.exports = __webpack_public_path__ + "img/nodata.ecd19770.png";